// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Xjo3","right":"styles_right__1HQn0"};